import { Controller } from "@hotwired/stimulus"

// Auto-submit toggle using native checkbox
// Usage:
//   <form data-controller="toggle" action="/settings" method="patch">
//     <input type="checkbox" name="user[setting]" data-action="change->toggle#submit">
//   </form>
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
